export function validateEmail(email) {
  if (!email || !email.trim()) return "Email is required"
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) return "Enter a valid email"
  return ""
}

export function validatePassword(password) {
  if (!password) return "Password is required"
  if (password.length < 8) return "Password must be at least 8 characters"
  return ""
}
